export const Types = {
  GET_REQUEST: 'channels/GET_REQUEST',
  GET_SUCCESS: 'channels/GET_SUCCESS',
  GET_FAILURE: 'channels/GET_FAILURE',

  GET_LIST_REQUEST: 'channels/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'channels/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'channels/GET_LIST_FAILURE',

  UPDATE_REQUEST: 'channels/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'channels/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'channels/UPDATE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  update: {
    loading: false,
  },
};

export default function channels(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.channel.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.channels.data,
        page: action.payload.channels.meta.current_page,
        totals: action.payload.channels.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getChannelRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getChannelSuccess: channel => ({
    type: Types.GET_SUCCESS,
    payload: { channel },
  }),

  getChannelFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getChannelsRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getChannelsSuccess: channels => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { channels },
  }),

  getChannelsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  updateChannelRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateChannelSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateChannelFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),
};
